import { Megaphone } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function InfoImportante() {
  const navigate = useNavigate();

  const notices = [
    "Assurez-vous que votre passeport est valide au moins 6 mois.",
    "Vérifiez les exigences de visa selon votre nationalité.",
    "Déclarez votre voyage au moins 72h avant votre départ.",
  ];

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="bg-brand-50 rounded-2xl p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="flex items-start gap-4 flex-1">
          <div className="w-12 h-12 rounded-full bg-white text-brand-600 flex items-center justify-center flex-shrink-0">
            <Megaphone size={22} />
          </div>
          <div>
            <h3 className="font-bold text-slate-800 text-base mb-2">Informations importantes</h3>
            <ul className="space-y-1 text-sm text-slate-700">
              {notices.map((n, i) => (
                <li key={i} className="flex gap-2">
                  <span className="text-brand-600">•</span>
                  <span>{n}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <button
          onClick={() => {}}
          className="bg-brand-600 hover:bg-brand-700 text-white font-semibold px-5 py-2.5 rounded-lg transition-colors text-sm whitespace-nowrap self-start md:self-center"
        >
          En savoir plus
        </button>
      </div>
    </section>
  );
}
